export const HOME_TEM_MAIN = [
  {
    //申请单
    id: "apply",
    title: "HOME.TEM_MAIN_APPLY",
    imgUrl: "assets/imgs/sqd.png",
    className: "icon-box bg-a",
    isAdded: false,
    disabled: false,
  },
  {
    //差旅（国内）
    id: "travelInland",
    title: "HOME.TEM_MAIN_TRAVELINLAND",
    imgUrl: "assets/imgs/bxd.png",
    className: "icon-box bg-f",
    isAdded: false,
    disabled: false,
  },
  {
    //差旅（国外）
    id: "travelOutland",
    title: "HOME.TEM_MAIN_TRAVELOUTLAND",
    imgUrl: "assets/imgs/jkd.png",
    className: "icon-box bg-b",
    isAdded: false,
    disabled: false,
  },
  {
    //通讯费
    id: "communite",
    title: "HOME.TEM_MAIN_COMMUNITE",
    imgUrl: "assets/imgs/sqd.png",
    className: "icon-box bg-d",
    isAdded: false,
    disabled: false,
  },
  {
    //业务招待费
    id: "business",
    title: "HOME.TEM_MAIN_BUSINESS",
    imgUrl: "assets/imgs/bxd.png",
    className: "icon-box bg-c",
    isAdded: false,
    disabled: false,
  },
  {
    //通用费用
    id: "general",
    title: "HOME.TEM_MAIN_GENERAL",
    imgUrl: "assets/imgs/sqd.png",
    className: "icon-box bg-e",
    isAdded: false,
    disabled: false,
  },
  {
    //借款单
    id: "borrow",
    title: "HOME.TEM_MAIN_BORROW",
    imgUrl: "assets/imgs/jkd.png",
    className: "icon-box bg-f",
    isAdded: false,
    disabled: false,
  },
  {
    //还款单
    id: "also",
    title: "HOME.TEM_MAIN_ALSO",
    imgUrl: "assets/imgs/bxd.png",
    className: "icon-box bg-b",
    isAdded: false,
    disabled: false,
  },
];

export const HOME_TEM_SECOND = [
  {
    //我的申请
    id: "apply",
    title: "HOME.TEM_SECOND_APPLY",
    imgUrl: "assets/imgs/sqd.png",
    className: "icon-box bg-a",
    badgeId: "applyNum",
    badge: 0,
    isAdded: false,
    disabled: false,
  },
  {
    //我的报账
    id: "reimburse",
    title: "HOME.TEM_SECOND_REIMBURSE",
    imgUrl: "assets/imgs/bxd.png",
    className: "icon-box bg-f",
    badgeId: "reimburseNum",
    badge: 0,
    isAdded: false,
    disabled: false,
  },
  {
    //我的借还款
    id: "borrow",
    title: "HOME.TEM_SECOND_BORROW",
    imgUrl: "assets/imgs/jkd.png",
    className: "icon-box bg-b",
    badgeId: "borrowNum",
    badge: 0,
    isAdded: false,
    disabled: false,
  },
  {
    //我的草稿
    id: "draft",
    title: "HOME.TEM_SECOND_DRAFT",
    imgUrl: "assets/imgs/sqd.png",
    className: "icon-box bg-c",
    badgeId: "draftNum",
    badge: 0,
    isAdded: false,
    disabled: false,
  },
  {
    //我的退单
    id: "back",
    title: "HOME.TEM_SECOND_BACK",
    imgUrl: "assets/imgs/jkd.png",
    className: "icon-box bg-e",
    badgeId: "backbillNum",
    badge: 0,
    isAdded: false,
    disabled: false,
  },
];

export const HOME_TEM_LIST = [
  {
    //报账在途
    id: "beingReimburse",
    title: "HOME.TEM_LIST_REIMBURSE",
    lists: [],
    isAdded: false,
    disabled: false,
  },
  {
    //申请在途
    id: "beingApply",
    title: "HOME.TEM_LIST_APPLY",
    lists: [],
    isAdded: false,
    disabled: false,
  },
  // {//借还款在途
  //     id: "beingBorrowandalso",
  //     title: "HOME.TEM_LIST_BORROWANDALSO",
  //     lists: [],
  //     isAdded: false,
  //     disabled: false,
  // }
];



// WEBPACK FOOTER //
// ./src/config/hometem.config.ts